import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ReactComponent as Icon1 } from "../../Svg/HomeS5P2Img2.svg";
import { ReactComponent as Icon2 } from "../../Svg/HomeS5P2Img13.svg";
import { ReactComponent as Icon3 } from "../../Svg/HomeS5P2Img12.svg";
import { ReactComponent as Icon4 } from "../../Svg/HomeS5P2Img6.svg";
import { ReactComponent as Icon5 } from "../../Svg/HomeS5P2Img10.svg";
import { ReactComponent as Icon6 } from "../../Svg/HomeS5P2Img11.svg";
import { ReactComponent as Icon7 } from "../../Svg/HomeS5P2Img9.svg";

import "./choice.css";

const ChoiceButton = ({ choice, isSelected, onClick }) => {
  const SVGComponent = choice.Icon;
  const Location = useLocation();
  const isArabic = Location.pathname.endsWith("/ar");

  return (
    <>
      {isArabic ? (
        <button className={`choice_button_Ar Ar ${isSelected ? "selected" : ""}`} onClick={onClick} type="button" name="user_choices">
          <SVGComponent className={`choice-svg ${isSelected ? "active" : ""} ${choice.id === 7 ? "icon7" : ""}`} />
          {choice.label}
        </button>
      ) : (
        <button className={`choice-button ${isSelected ? "selected" : ""}`} onClick={onClick} type="button" name="user_choices">
          <SVGComponent className={`choice-svg ${isSelected ? "active" : ""} ${choice.id === 6 ? "icon7" : ""}`} />
          {choice.label}
        </button>
      )}
    </>
  );
};

const Choices = ({ onChoicesChange }) => {
  const [selectedChoices, setSelectedChoices] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const Location = useLocation();
  const isArabic = Location.pathname.endsWith("/ar");

  const choices = isArabic
    ? [
        { id: 1, label: "التعليم", Icon: Icon1 },
        { id: 2, label: "الطبي ", Icon: Icon2 },
        { id: 3, label: "كاجوال ", Icon: Icon3 },
        { id: 4, label: "الصناعة", Icon: Icon4 },
        { id: 5, label: "الضيافة", Icon: Icon5 },
        { id: 6, label: "الرياضية", Icon: Icon6 },
        { id: 7, label: "الشركات", Icon: Icon7 },
      ]
    : [
        { id: 1, label: "EDUCATIONAL ", Icon: Icon1 },
        { id: 2, label: "CASUAL ", Icon: Icon6 },
        { id: 3, label: "INDUSTRIAL ", Icon: Icon4 },
        { id: 4, label: "HOSPITALITY ", Icon: Icon2 },
        { id: 5, label: "SPORTS WEAR ", Icon: Icon3 },
        { id: 6, label: "CORPORATE ", Icon: Icon7 },
        { id: 7, label: "MEDICAL ", Icon: Icon5 },
      ];

  const toggleChoice = (choiceId) => {
    const choice = choices.find((c) => c.id === choiceId);

    const isCurrentlySelected = selectedChoices.some((c) => c.id === choiceId);

    const newSelectedChoices = isCurrentlySelected ? selectedChoices.filter((c) => c.id !== choiceId) : [...selectedChoices, choice];

    setSelectedChoices(newSelectedChoices);

    onChoicesChange(newSelectedChoices);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <div className="choices-container">
      {choices.map((choice) => (
        <React.Fragment key={choice.id}>
          <ChoiceButton choice={choice} isSelected={selectedChoices.some((c) => c.id === choice.id)} onClick={() => toggleChoice(choice.id)} />
          <input type="hidden" name="user_choices" value={selectedChoices.some((c) => c.id === choice.id) ? choice.label : ""} style={{ display: "none" }} />
        </React.Fragment>
      ))}
    </div>
  );
};

export default Choices;
